"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserWithTrusted = void 0;
const react_1 = require("react");
const useAuthoriserBase_hook_1 = __importDefault(require("../useAuthoriser/useAuthoriserBase.hook"));
const initializer_1 = require("../../../initializer");
const AuthoriserWithTrustedDevice = initializer_1.Authoriser;
const useAuthoriserWithTrusted = ({ onStart, onFail, onReadyToFinish, onFinish, onVerify, onVerifyError, onTrustedDeviceRequired, } = {}) => {
    const useAuthoriserData = (0, useAuthoriserBase_hook_1.default)({
        authoriser: AuthoriserWithTrustedDevice,
        onStart,
        onFail,
        onReadyToFinish,
        onFinish,
        onVerify,
        onVerifyError,
    });
    const [state, setState] = (0, react_1.useState)({
        ...useAuthoriserData.state,
        isTrustedDeviceRequired: AuthoriserWithTrustedDevice.state.isTrustedDeviceRequired,
    });
    (0, react_1.useEffect)(() => {
        const onStateChangeUnbSubscribe = AuthoriserWithTrustedDevice.onStateChange(newState => {
            setState(newState);
        });
        return () => {
            onStateChangeUnbSubscribe();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        state.isTrustedDeviceRequired && onTrustedDeviceRequired?.();
    }, [state.isTrustedDeviceRequired]);
    return {
        ...useAuthoriserData,
        isTrustedDeviceRequired: state.isTrustedDeviceRequired,
        state: state,
    };
};
exports.useAuthoriserWithTrusted = useAuthoriserWithTrusted;
//# sourceMappingURL=useAuthoriserWithTrusted.hook.js.map